import React from 'react';
import { Layout } from '../../components/Layout';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { Container } from '../../components/ui/Container';
import { Section } from '../../components/ui/Section';
import { Mail, MessageSquare, Shield, AlertTriangle, ArrowRight, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Contact() {
  return <Layout data-id="element-765">
      <Section spacing="lg" data-id="element-766">
        <Container size="lg" data-id="element-767">
          {/* Hero */}
          <div className="mb-12 text-center animate-fade-in-up" data-id="element-768">
            <Badge variant="primary" size="lg" className="mb-6" data-id="element-769">
              Get in Touch
            </Badge>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-100 mb-6" data-id="element-770">
              Contact Us
            </h1>
            <p className="text-lg md:text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-771">
              Questions, feedback, or collaboration inquiries? We're here to
              help build a safer digital world.
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8" data-id="element-772">
            {/* Main Content */}
            <div className="lg:col-span-2 space-y-12" data-id="element-773">
              {/* Primary Contact */}
              <section className="animate-fade-in-up animation-delay-100" data-id="element-774">
                <h2 className="text-2xl font-bold text-slate-100 mb-6 font-mono" data-id="element-775">
                  Primary Contact
                </h2>
                <Card glass padding="lg" className="border-cyan-500/20" data-id="element-776">
                  <div className="flex items-start space-x-4" data-id="element-777">
                    <div className="h-14 w-14 rounded-xl bg-cyan-500/10 flex items-center justify-center text-cyan-400 flex-shrink-0" data-id="element-778">
                      <Mail className="h-7 w-7" data-id="element-779" />
                    </div>
                    <div data-id="element-780">
                      <h3 className="text-xl font-bold text-slate-100 mb-2" data-id="element-781">
                        General Inquiries
                      </h3>
                      <p className="text-slate-400 mb-4" data-id="element-782">
                        For all questions, feedback, partnerships, and general
                        inquiries about the platform.
                      </p>
                      <a href="mailto:contact@cybersecurityprotocol.org" className="inline-flex items-center text-cyan-400 hover:text-cyan-300 font-semibold transition-colors" data-id="element-783">
                        contact@cybersecurityprotocol.org
                        <ExternalLink className="h-4 w-4 ml-2" data-id="element-784" />
                      </a>
                    </div>
                  </div>
                </Card>
              </section>

              {/* What We Can Help With */}
              <section className="animate-fade-in-up animation-delay-200" data-id="element-785">
                <h2 className="text-2xl font-bold text-slate-100 mb-6 font-mono" data-id="element-786">
                  What We Can Help With
                </h2>
                <Card glass padding="lg" data-id="element-787">
                  <div className="grid sm:grid-cols-2 gap-8" data-id="element-788">
                    <div data-id="element-789">
                      <h3 className="font-bold text-emerald-400 mb-4 flex items-center" data-id="element-790">
                        <span className="text-emerald-500 mr-2" data-id="element-791">✓</span>
                        We Can Help With:
                      </h3>
                      <ul className="space-y-3 text-slate-400 text-sm" data-id="element-792">
                        <li className="flex items-start" data-id="element-793">
                          <span className="text-emerald-500 mr-2 mt-0.5" data-id="element-794">
                            ▸
                          </span>
                          Questions about our protocols and methodologies
                        </li>
                        <li className="flex items-start" data-id="element-795">
                          <span className="text-emerald-500 mr-2 mt-0.5" data-id="element-796">
                            ▸
                          </span>
                          Feedback on content accuracy and updates
                        </li>
                        <li className="flex items-start" data-id="element-797">
                          <span className="text-emerald-500 mr-2 mt-0.5" data-id="element-798">
                            ▸
                          </span>
                          Partnership and collaboration opportunities
                        </li>
                        <li className="flex items-start" data-id="element-799">
                          <span className="text-emerald-500 mr-2 mt-0.5" data-id="element-800">
                            ▸
                          </span>
                          Speaking engagements and educational programs
                        </li>
                        <li className="flex items-start" data-id="element-801">
                          <span className="text-emerald-500 mr-2 mt-0.5" data-id="element-802">
                            ▸
                          </span>
                          Media inquiries and press requests
                        </li>
                      </ul>
                    </div>
                    <div data-id="element-803">
                      <h3 className="font-bold text-red-400 mb-4 flex items-center" data-id="element-804">
                        <span className="text-red-500 mr-2" data-id="element-805">✕</span>
                        We Cannot Help With:
                      </h3>
                      <ul className="space-y-3 text-slate-400 text-sm" data-id="element-806">
                        <li className="flex items-start" data-id="element-807">
                          <span className="text-red-500 mr-2 mt-0.5" data-id="element-808">▸</span>
                          Individual security consulting or audits
                        </li>
                        <li className="flex items-start" data-id="element-809">
                          <span className="text-red-500 mr-2 mt-0.5" data-id="element-810">▸</span>
                          Active incident response services
                        </li>
                        <li className="flex items-start" data-id="element-811">
                          <span className="text-red-500 mr-2 mt-0.5" data-id="element-812">▸</span>
                          Legal advice or representation
                        </li>
                        <li className="flex items-start" data-id="element-813">
                          <span className="text-red-500 mr-2 mt-0.5" data-id="element-814">▸</span>
                          Offensive security or penetration testing
                        </li>
                        <li className="flex items-start" data-id="element-815">
                          <span className="text-red-500 mr-2 mt-0.5" data-id="element-816">▸</span>
                          Exploit development or vulnerability research
                        </li>
                      </ul>
                    </div>
                  </div>
                </Card>
              </section>

              {/* Responsible Disclosure */}
              <section className="animate-fade-in-up animation-delay-300" data-id="element-817">
                <h2 className="text-2xl font-bold text-slate-100 mb-6 font-mono flex items-center" data-id="element-818">
                  <Shield className="h-6 w-6 mr-3 text-cyan-400" data-id="element-819" />
                  Responsible Disclosure Policy
                </h2>
                <Card glass padding="lg" className="border-amber-500/20" data-id="element-820">
                  <div className="flex items-start space-x-4 mb-6" data-id="element-821">
                    <div className="h-12 w-12 rounded-xl bg-amber-500/10 flex items-center justify-center text-amber-400 flex-shrink-0" data-id="element-822">
                      <AlertTriangle className="h-6 w-6" data-id="element-823" />
                    </div>
                    <div data-id="element-824">
                      <h3 className="text-lg font-bold text-slate-100 mb-2" data-id="element-825">
                        Security Vulnerability Reporting
                      </h3>
                      <p className="text-slate-400 text-sm" data-id="element-826">
                        If you discover a security vulnerability in our
                        platform, we appreciate your responsible disclosure.
                      </p>
                    </div>
                  </div>

                  <div className="space-y-4 text-sm text-slate-400" data-id="element-827">
                    <div data-id="element-828">
                      <h4 className="font-semibold text-slate-200 mb-2" data-id="element-829">
                        Please Report To:
                      </h4>
                      <a href="mailto:contact@cybersecurityprotocol.org" className="text-cyan-400 hover:text-cyan-300 font-mono" data-id="element-830">
                        contact@cybersecurityprotocol.org
                      </a>
                      <p className="text-xs text-slate-500 mt-1" data-id="element-831">
                        Subject line: [SECURITY] Vulnerability Report
                      </p>
                    </div>

                    <div data-id="element-832">
                      <h4 className="font-semibold text-slate-200 mb-2" data-id="element-833">
                        Guidelines:
                      </h4>
                      <ul className="space-y-2" data-id="element-834">
                        <li className="flex items-start" data-id="element-835">
                          <span className="text-cyan-400 mr-2" data-id="element-836">▸</span>
                          <span data-id="element-837">
                            Do not exploit vulnerabilities beyond what is
                            necessary to demonstrate the issue
                          </span>
                        </li>
                        <li className="flex items-start" data-id="element-838">
                          <span className="text-cyan-400 mr-2" data-id="element-839">▸</span>
                          <span data-id="element-840">
                            Do not access, modify, or delete data that does not
                            belong to you
                          </span>
                        </li>
                        <li className="flex items-start" data-id="element-841">
                          <span className="text-cyan-400 mr-2" data-id="element-842">▸</span>
                          <span data-id="element-843">
                            Do not publicly disclose the vulnerability until we
                            have had time to address it
                          </span>
                        </li>
                        <li className="flex items-start" data-id="element-844">
                          <span className="text-cyan-400 mr-2" data-id="element-845">▸</span>
                          <span data-id="element-846">
                            Provide detailed information to help us reproduce
                            and fix the issue
                          </span>
                        </li>
                      </ul>
                    </div>

                    <div data-id="element-847">
                      <h4 className="font-semibold text-slate-200 mb-2" data-id="element-848">
                        Our Commitment:
                      </h4>
                      <ul className="space-y-2" data-id="element-849">
                        <li className="flex items-start" data-id="element-850">
                          <span className="text-emerald-400 mr-2" data-id="element-851">✓</span>
                          <span data-id="element-852">
                            We will acknowledge receipt within 48 hours
                          </span>
                        </li>
                        <li className="flex items-start" data-id="element-853">
                          <span className="text-emerald-400 mr-2" data-id="element-854">✓</span>
                          <span data-id="element-855">
                            We will provide regular updates on our progress
                          </span>
                        </li>
                        <li className="flex items-start" data-id="element-856">
                          <span className="text-emerald-400 mr-2" data-id="element-857">✓</span>
                          <span data-id="element-858">
                            We will credit you for the discovery (if desired)
                          </span>
                        </li>
                        <li className="flex items-start" data-id="element-859">
                          <span className="text-emerald-400 mr-2" data-id="element-860">✓</span>
                          <span data-id="element-861">
                            We will not pursue legal action for good-faith
                            security research
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Card>
              </section>

              {/* Response Time */}
              <section className="animate-fade-in-up animation-delay-400" data-id="element-862">
                <Card glass padding="md" className="bg-slate-900/30" data-id="element-863">
                  <div className="flex items-center space-x-3 text-sm text-slate-400" data-id="element-864">
                    <MessageSquare className="h-5 w-5 text-cyan-400" data-id="element-865" />
                    <p data-id="element-866">
                      <span className="font-semibold text-slate-200" data-id="element-867">
                        Response Time:
                      </span>{' '}
                      We aim to respond to all inquiries within 2-3 business
                      days. Security reports are prioritized and acknowledged
                      within 48 hours.
                    </p>
                  </div>
                </Card>
              </section>
            </div>

            {/* Sidebar */}
            <div className="space-y-6" data-id="element-868">
              <Card glass padding="lg" className="sticky top-24 animate-fade-in-up animation-delay-500" data-id="element-869">
                <h3 className="text-lg font-bold text-slate-100 mb-4 font-mono" data-id="element-870">
                  Quick Links
                </h3>
                <div className="space-y-2" data-id="element-871">
                  <Link to="/about/mission" className="block p-2 rounded hover:bg-slate-800/50 text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-872">
                    Mission & Vision
                  </Link>
                  <Link to="/about/scope" className="block p-2 rounded hover:bg-slate-800/50 text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-873">
                    Scope & Non-Guarantee
                  </Link>
                  <Link to="/about/standards" className="block p-2 rounded hover:bg-slate-800/50 text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-874">
                    Standards Mapping
                  </Link>
                  <Link to="/about/changelog" className="block p-2 rounded hover:bg-slate-800/50 text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-875">
                    Changelog
                  </Link>
                  <Link to="/about/governance" className="block p-2 rounded hover:bg-slate-800/50 text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-876">
                    Governance
                  </Link>
                  <Link to="/about/disclaimer" className="block p-2 rounded hover:bg-slate-800/50 text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-877">
                    Legal Disclaimer
                  </Link>
                  <Link to="/about/contact" className="block p-2 rounded bg-cyan-500/10 text-cyan-400 font-medium border border-cyan-500/20" data-id="element-878">
                    Contact Us
                  </Link>
                </div>

                <div className="mt-8 pt-6 border-t border-slate-800" data-id="element-879">
                  <h4 className="text-sm font-bold text-slate-400 uppercase mb-4 font-mono" data-id="element-880">
                    Start Learning
                  </h4>
                  <Link to="/start" className="block w-full" data-id="element-881">
                    <Button variant="primary" fullWidth data-id="element-882">
                      Get Started <ArrowRight className="ml-2 h-4 w-4" data-id="element-883" />
                    </Button>
                  </Link>
                </div>
              </Card>
            </div>
          </div>
        </Container>
      </Section>
    </Layout>;
}